// extracted by mini-css-extract-plugin
export default {"iconBtnWrapper":"Icon_iconBtnWrapper__4j4w-","icon":"Icon_icon__DW+Kv"};